import script from "./searchJob.vue?vue&type=script&setup=true&lang=js"
export * from "./searchJob.vue?vue&type=script&setup=true&lang=js"

import "./searchJob.vue?vue&type=style&index=0&id=5351f068&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5351f068"]])

export default __exports__